import React, { useState, useEffect } from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { MQTTProvider } from './context/MQTTContext';
import AppShell from './layout/AppShell';
import DashboardPage   from './pages/DashboardPage';
import LivePage        from './pages/LivePage';
import AnalyticsPage   from './pages/AnalyticsPage';
import GPSPage         from './pages/GPSPage';
import AlertsPage      from './pages/AlertsPage';
import AIInsightsPage  from './pages/AIInsightsPage';
import SettingsPage    from './pages/SettingsPage';

function App() {
  const [theme, setTheme] = useState(() => localStorage.getItem('theme') || 'light');

  useEffect(() => {
    localStorage.setItem('theme', theme);
    document.documentElement.setAttribute('data-theme', theme);
    document.documentElement.classList.toggle('dark', theme === 'dark');
    document.body.classList.toggle('dark-theme', theme === 'dark');
  }, [theme]);

  const toggleTheme = () => setTheme(t => (t === 'light' ? 'dark' : 'light'));

  return (
    <MQTTProvider>
      <BrowserRouter>
        <Routes>
          <Route element={<AppShell theme={theme} onToggleTheme={toggleTheme} />}>
            <Route index           element={<DashboardPage />} />
            <Route path="live"     element={<LivePage />} />
            <Route path="analytics" element={<AnalyticsPage />} />
            <Route path="gps"      element={<GPSPage />} />
            <Route path="alerts"   element={<AlertsPage />} />
            <Route path="ai"       element={<AIInsightsPage />} />
            <Route path="settings" element={<SettingsPage />} />
            <Route path="*"        element={<Navigate to="/" replace />} />
          </Route>
        </Routes>
      </BrowserRouter>
    </MQTTProvider>
  );
}

export default App;
